import logger from '../utils/rbmc.logger';
import spinner from '../utils/rbmc.spinner';

const expressShipping = {
    changeExpressShipping(value) {
        let request = $.ajax({
            url:     '/switchexpressdelivery',
            method:  'POST',
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded'
            },
            data:    {
                'expressShippingSelected': value
            },
            cache:   false
        });
        spinner.spinnerVisibility(true);
        request.then(() => {
                    window.location.reload(true);
                }, () => {
                    spinner.spinnerVisibility(false);
                    logger.error('changeExpressShipping failed');
                }
        );
    },
    bindHandlers() {
        $('.js-express-shipping-remove').on('click', (evt) => {
            evt.preventDefault();
            logger.log('remove express shipping');
            this.changeExpressShipping(false);
        });
        $('#express-shipping input[type=radio]').on('change', (evt) => {
            this.changeExpressShipping(evt.currentTarget.value);
        });
        $('#express-shipping').addClass('express-shipping__content--visible');
    }
};
$(() => {
    if ($('.checkoutpage').length) {
        expressShipping.bindHandlers();
    }
});

export default expressShipping
